<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25"
      >
        <md-button class="big-button" v-on:click="navigateToUserProfile"><md-icon class="big-button-icon">account_circle_black</md-icon>
          {{ $t('user_settings') }}</md-button>
      </div>
      <!--<div
          class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25"
      >
        <md-button class="big-button" v-on:click="navigateToCompanyProfile"><md-icon class="big-button-icon">business</md-icon>
          Unternehmensprofil</md-button>
      </div>-->
      <div
          class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25"
      >
        <md-button class="big-button" v-on:click="navigateToAutomaticReports"><md-icon class="big-button-icon">feed</md-icon>
          {{ $t('automated_reports') }}</md-button>
      </div>
      <!--<div
          class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25"
      >
        <md-button class="big-button" v-on:click="navigateToRolesAndRights"><md-icon class="big-button-icon">groups</md-icon>
          Rollen und Berechtigungen</md-button>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  methods: {
    navigateToUserProfile() {
      this.$router.push("/app/settings/user");
    },
    navigateToCompanyProfile() {
      this.$router.push("/app/settings/company");
    },
    navigateToAutomaticReports() {
      this.$router.push("/app/settings/reports");
    },
    navigateToRolesAndRights() {
      this.$router.push("/app/settings/roles");
    }
  }
};
</script>

<style scoped>
.big-button {
  width: 373px;
  height: 150px;

  background: linear-gradient(90deg, #26C6DA 0%, #00ACC1 100%);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
.md-button:not(.md-just-icon) .md-button-content i {
  font-size: 50px !important;
  height: 56px;
  display: block;
  margin-right: 50px;
}
</style>
